import axios from "axios";
import endpoints from "../utils/endpoints";
import { accessToken } from "../utils/token";

const listCOA = async (params?: { keyword?: string }) => {
  const { data: response } = await axios.get(endpoints.COA, {
    headers: {
      Authorization: accessToken,
    },
    params,
  });

  return response;
};

const getCOADetail = async (code: string) => {
  const { data: response } = await axios.get(endpoints.DETAIL_COA(code), {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const createCOA = async (params: { code: string; description: string; type: string }) => {
  const { data: response } = await axios.post(endpoints.COA, params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const updateCOA = async (
  code: string,
  params: { description: string; type: string }
) => {
  const { data: response } = await axios.patch(endpoints.DETAIL_COA(code), params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const deleteCOA = async (code: string) => {
  const { data: response } = await axios.delete(endpoints.DETAIL_COA(code), {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const coaService = {
  listCOA,
  getCOADetail,
  createCOA,
  updateCOA,
  deleteCOA,
};

export default coaService;
